module.exports = "/_next/static/images/ourPartnersConsolidatedLogo-eae850d9a7f84a3c434adb94aaefaafc.webp";